"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
/**
* @module radspec/helpers/HelperManager
*/

/**
* Class for managing the execution of helper functions
*
* @class HelperManager
* @param {Object} availableHelpers Defined helpers
*/

var HelperManager = /*#__PURE__*/function () {
  function HelperManager() {
    var availableHelpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, HelperManager);

    this.availableHelpers = availableHelpers;
  }
  /**
  * Does a helper exist
  *
  * @param  {string} helper Helper name
  * @return {bool}
  */


  _createClass(HelperManager, [{
    key: "exists",
    value: function exists(helper) {
      return !!this.availableHelpers[helper];
    }
    /**
    * Execute a helper with some inputs
    *
    * @param  {string} helper Helper name
    * @param  {Array<radspec/evaluator/TypedValue>} inputs
    * @param  {Object} config Configuration for running helper
    * @param {ethers.providers.Provider} config.provider Current provider
    * @param  {radspec/evaluator/Evaluator} config.evaluator Current evaluator
    * @return {Promise<radspec/evaluator/TypedValue>}
    */

  }, {
    key: "execute",
    value: function execute(helper, inputs, _ref) {
      var provider = _ref.provider,
          evaluator = _ref.evaluator;
      // pass values directly
      return inputs = inputs.map(function (input) {
        return input.value;
      }), this.availableHelpers[helper](provider, evaluator).apply(void 0, _toConsumableArray(inputs));
    }
    /**
    * Get all registered helpers as a key-value mapping
    *
    * @return {Object}
    */

  }, {
    key: "getHelpers",
    value: function getHelpers() {
      return this.availableHelpers;
    }
  }]);

  return HelperManager;
}();

exports.default = HelperManager;